import React from 'react'
import EmployeeUserLogin from '../feature/Login/EmployeeUserLogin'

const EmployeeUserLoginPage = () => {
    return (
        <EmployeeUserLogin />
    )
}

export default EmployeeUserLoginPage
